/// <amd-module name="Repos/Views/Settings/Repositories-Policies/Components/InheritedValuesTable" />
import React = require("react");
import { IPolicy } from "Repos/Views/Settings/Repositories-Policies/Contracts/Contracts";
import * as Resources from "Repos/Views/Settings/Repositories-Policies/Resources";
import { IObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Pill, PillSize } from "VSSUI/Pill";
import { ITableColumn, SimpleTableCell, Table, TableColumnLayout } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";

interface IInheritedValuesTableProps {
    policy: IPolicy;
}

export class InheritedValuesTable extends VssComponent<IInheritedValuesTableProps> {
    private items: IObservableArray<IPolicy>;

    public constructor(props: IInheritedValuesTableProps, context: IVssComponentContext) {
        super(props, context);

        this.items = new ObservableArray<IPolicy>(props.policy.activeInheritedAndEnterprisePolicies || []);

        if (props.policy.additonalCurrentScopePolicies) {
            this.items.push(...props.policy.additonalCurrentScopePolicies);
        }
    }

    public render = (): JSX.Element => {
        return (
            <div className="padding-top-16">
                <h3 className="font-weight-normal">{Resources.InheritedValues}</h3>
                <Table<IPolicy> columns={this.getColumns()} itemProvider={this.items} role="table" />
            </div>
        );
    };

    private getColumns = (): ITableColumn<{}>[] => {
        return [
            {
                columnLayout: TableColumnLayout.singleLinePrefix,
                id: "configuredOn",
                name: Resources.ConfiguredOn,
                readonly: true,
                renderCell: this.renderCellConfiguredOn,
                width: -35
            },
            {
                columnLayout: TableColumnLayout.singleLinePrefix,
                id: "configuredValue",
                name: Resources.ConfiguredValue,
                readonly: true,
                renderCell: this.renderCellConfiguredValue,
                width: -65
            },
            {
                id: "readOnly",
                name: "",
                ariaLabel: Resources.ReadOnly,
                readonly: true,
                renderCell: this.renderCellReadOnly,
                width: 95
            }
        ];
    };

    private renderCellConfiguredOn = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IPolicy>, tableItem: IPolicy): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={tableItem.id + "co"} tableColumn={tableColumn}>
                <div className="flex-column text-ellipsis">
                    <div className="text-ellipsis">
                        <Tooltip text={tableItem.scopeString}>
                            <span>{tableItem.scopeString}</span>
                        </Tooltip>
                    </div>
                </div>
            </SimpleTableCell>
        );
    };

    private renderCellConfiguredValue = (
        rowIndex: number,
        columnIndex: number,
        tableColumn: ITableColumn<IPolicy>,
        tableItem: IPolicy
    ): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={tableItem.id + "cv"} tableColumn={tableColumn}>
                <div className="flex-column text-ellipsis">
                    <div className="text-ellipsis">
                        <Tooltip text={tableItem.settingValue}>
                            <span>{tableItem.settingValue || ""}</span>
                        </Tooltip>
                    </div>
                </div>
            </SimpleTableCell>
        );
    };

    private renderCellReadOnly = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IPolicy>, tableItem: IPolicy): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={tableItem.id + "ro"} tableColumn={tableColumn}>
                <div className="flex-column">
                    {tableItem.isEnterpriseManaged && (
                        <Tooltip text={Resources.ReadOnlyTooltip}>
                            <Pill size={PillSize.compact}>{Resources.ReadOnly}</Pill>
                        </Tooltip>
                    )}
                </div>
            </SimpleTableCell>
        );
    };
}
